import React from 'react';
import { motion } from 'framer-motion';

const StepsSection = () => {
  const steps = [
    "קל, עונים על מספר שאלות ואנחנו בונים ומאמנים את הבוט לפי דרישת הלקוח.",
    "אפשרות חיבור הסוכן למקורות כמו אתר/WhatsApp/Facebook ועוד.",
    "הסוכן מתחיל לענות, לאסוף, למיין ולהתריע – ואתם נהנים מעובד AI שעובד בשבילכם 24/7, 365 יום בשנה!"
  ];

  return (
    <section className="steps-section section bg-gray-50">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            איך זה עובד (3 צעדים)
          </h2>
        </motion.div>
        
        <div className="steps-container max-w-4xl mx-auto">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="step-item flex items-start gap-6 mb-12 last:mb-0"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
            >
              <div className="step-number flex-shrink-0 w-12 h-12 bg-purple-600 text-white rounded-full flex items-center justify-center text-xl font-bold">
                {index + 1}
              </div>
              <div className="step-content bg-white p-6 rounded-xl shadow-lg flex-1">
                <p className="text-lg text-gray-700 leading-relaxed">{step}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StepsSection;